import ThinkTank from './container';

export default ThinkTank;



// WEBPACK FOOTER //
// ./src/routes/ThinkTank/index.js